<template>
  <div class="main">
    <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="modelMenu" current="装车率" />

        <div  class="r action-btn-box" v-show="!viewResult">
           <el-button @click="modifyDate"  type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round >装车率分析 <svg-icon name="play" size="12" ></svg-icon> </el-button> 
          </div>
      <xy-toolbox-menu class="r" v-show="viewResult">
        <xy-toolbox-menu-item icon="car_search" @click="goto">返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="date" @click="modifyDate">调整时间</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出</xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult">
    
    </SearchBar>

    <div v-if="viewResult" style="margin-top: 40px" v-loading="isLoading">
      <el-table :data="tableData" :span-method="objectSpanMethod" border height="650" style="width: 98%; margin: 20px 10px 10px 10px">
        <el-table-column prop="tag" label="装备分类" align="center" width="180">
        </el-table-column>
        <el-table-column prop="name" label="装备名称"></el-table-column>
        <el-table-column prop="val" label="装备名称"></el-table-column>
        <el-table-column align="center" :label="dateLabel" prop="data">
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="选择时间范围" :visible.sync="showModifyDate" :center="false" :append-to-body="true">
      <span slot="dialog-title"> </span>
      <el-row>
        <el-col :span="24" type="flex" justify="end">
          <el-date-picker v-model="value2" type="monthrange" align="right" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" :picker-options="pickerOptions">
          </el-date-picker>
        </el-col>
      </el-row>
      <div></div>

      <span slot="footer">
        <el-button type="primary" @click="updateData">查询</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import SearchBar from "@/components/common/NewSearchBar.vue";

//import mock_data from '../../store/mock/installedratiomock.js';
export default {
  name: "saleanalysis",
  components: { SearchBar },
  data() {
    return {
      tableCfg: null,
      viewResult: false,
      showModifyDate: false,
      currentMonth: "",
      currentModuleName: "EinbaurateAnalysis",
      tableData: [],
      date_list: [],
      date_list_tmp: [],
      value2: "",
      dateLabel: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "本月",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "今年至今",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions("equipanalysis", ["queryEinbaurate"]),
    toPercent(point) {
      if (point == 0) {
        return 0;
      }
      var str = Number(point * 100).toFixed();
      str += "%";
      return str;
    },
    goto() {
      this.viewResult = !this.viewResult;
    },
    removeDate(index) {
      this.date_list_tmp.splice(index, 1);
    },
    addDate() {
      if (this.currentMonth == "") return;
      this.date_list_tmp.push(this.currentMonth);
    },
    modifyDate() {
      this.date_list_tmp = [];
      this.date_list_tmp.push(...this.date_list);
      this.showModifyDate = true;
    },
    updateData() {
      this.showModifyDate = false;
      this.viewResult = true;
      var ls = this.value2;
      this.dateLabel = ls[0] + "至" + ls[1];
      this.date_list = [];
      this.date_list.push(...ls);
      this.gotoInstalledRatioAnalysis();
    },
    exportExcel() {
      this.JSONToExcelConvertor(this.tableData, "report");
    },
    praseTable() {
      let len = this.tableData.length;
      //获取大分类
      var categories = new Set(
        this.tableData.map((x) => {
          return x.tag;
        })
      );
      console.log(categories);
      var dict = new Map();
      categories.forEach(function (value) {
        dict.set(value, { startIndex: 10000000, endIndex: 0 });
      });
      var tableCfg = [...categories].map((x) => {
        return { name: x, startIndex: 0, endIndex: 0 };
      });
      for (var i = 0; i < len; i++) {
        let key = this.tableData[i].tag;
        var di = dict.get(key);
        if (di.endIndex < i) {
          di.endIndex = i;
        }
        if (di.startIndex > i) {
          di.startIndex = i;
        }
      }
      this.tableCfg = dict;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      var cfg = this.tableCfg.get(row.tag);
      if (columnIndex === 0) {
        let count = cfg.endIndex - cfg.startIndex + 1;
        if (rowIndex === cfg.startIndex) {
          return { rowspan: count, colspan: 1 };
        } else if (rowIndex > cfg.startIndex && rowIndex <= cfg.endIndex) {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },
    setViewResult(isShow) {
      this.viewResult = isShow;
    },
    gotoInstalledRatioAnalysis() {
      var ids = this.searchResult.map((item) => {
        return parseInt(item.id);
      });
      var postData = { ids: ids, date_list: this.date_list };
      this.queryEinbaurate({ params: postData, handle: this.setViewResult });
    },
    bindTable() {
      this.tableData = [];
      for (var item of this.einbaurateList) {
        //转换是不需要的
        this.tableData.push(item);
      }
      this.praseTable();
    },
    JSONToExcelConvertor(JSONData, FileName, title, filter) {
      if (!JSONData) return;
      //转化json为object
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      var excel = "<table>";
      //设置表头
      var row = "<tr>";
      if (title) {
        //使用标题项
        for (var i in title) {
          row += "<th align='center'>" + title[i] + "</th>";
        }
      } else {
        //不使用标题项
        for (var i in arrData[0]) {
          row += "<th align='center'>" + i + "</th>";
        }
      }
      excel += row + "</tr>";
      //设置数据
      for (var i = 0; i < arrData.length; i++) {
        var row = "<tr>";
        for (var index in arrData[i]) {
          //判断是否有过滤行
          if (filter) {
            if (filter.indexOf(index) == -1) {
              var value = arrData[i][index] == null ? "" : arrData[i][index];
              row += "<td>" + value + "</td>";
            }
          } else {
            var value = arrData[i][index] == null ? "" : arrData[i][index];
            row += "<td align='center'>" + value + "</td>";
          }
        }
        excel += row + "</tr>";
      }
      excel += "</table>";
      var excelFile =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
      excelFile +=
        '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      excelFile +=
        '<meta http-equiv="content-type" content="application/vnd.ms-excel';
      excelFile += '; charset=UTF-8">';
      excelFile += "<head>";
      excelFile += "<!--[if gte mso 9]>";
      excelFile += "<xml>";
      excelFile += "<x:ExcelWorkbook>";
      excelFile += "<x:ExcelWorksheets>";
      excelFile += "<x:ExcelWorksheet>";
      excelFile += "<x:Name>";
      excelFile += "{worksheet}";
      excelFile += "</x:Name>";
      excelFile += "<x:WorksheetOptions>";
      excelFile += "<x:DisplayGridlines/>";
      excelFile += "</x:WorksheetOptions>";
      excelFile += "</x:ExcelWorksheet>";
      excelFile += "</x:ExcelWorksheets>";
      excelFile += "</x:ExcelWorkbook>";
      excelFile += "</xml>";
      excelFile += "<![endif]-->";
      excelFile += "</head>";
      excelFile += "<body>";
      excelFile += excel;
      excelFile += "</body>";
      excelFile += "</html>";
      var uri =
        "data:application/vnd.ms-excel;charset=utf-8," +
        encodeURIComponent(excelFile);
      var link = document.createElement("a");
      link.href = uri;
      link.style = "visibility:hidden";
      link.download = FileName + ".xls";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    getPreMonth(date) {
      var arr = date.split("-");
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
        year2 = parseInt(year2) - 1;
        month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
        day2 = days2;
      }
      if (month2 < 10) {
        month2 = "0" + month2;
      }
      var t2 = year2 + "-" + month2 + "-" + day2;
      return t2;
    },
  },
  created() {
    var myDate = new Date();
    var end = myDate.getFullYear() + "-" + (myDate.getMonth() + 1) + "-01";

    var start = this.getPreMonth(end);
    this.date_list.push(start);
    this.date_list.push(end);
    this.dateLabel = start + "至" + end;
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.loadingCount > 0,
    }),
    ...mapGetters("equipanalysis", {
      einbaurateList: "einbaurateList",
    }),
    ...mapGetters("commonsearch", {
      searchResult: "selectionResult",
      savedResultSchemas: "savedResultSchemas",
      pivotTableKey: "pivotTableKey",
      showSubmodel: "showSelectionSubmodel",
    }),
  },
  mounted() { },
  watch: {
    viewResult(value) {
      if (value) {
        this.bindTable();
      }
    },
    einbaurateList(value) {
      this.bindTable();
    },
  },
};
</script>
